import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getRequest, postRequest} from "../../api";
export const handleGetCategories = createAsyncThunk('movements/getCategories', async(parent_id) => {
    try{
        let params = null;
        if (parent_id) {
            params = { 'parent_id  ': `${parent_id}` };
        }
        const {data} = await getRequest('/motion/category', params);
        return data
    }
    catch(error){
        console.log(error)
    }
})

export const handleGetMovements = createAsyncThunk('movements/handleGetMovements', async(param) => {
    try{
        const {data} = await getRequest('/motion/1', param);
        return data
    }
    catch(error){
        console.log(error)
    }
})

export const handleGetComments = createAsyncThunk('movements/handleGetComments', async(allData) => {
    const {tempPage, param, isNotMoreComments} = allData
    try{
        const {data} = await getRequest(`coach/motion/comment/${tempPage}`, param)
        return {data, isNotMoreComments, tempPage}
    }
    catch(err){
        console.log(err)
    }
})

export const handleLikeComment = createAsyncThunk('movements/handleLikeComment', async(allData) => {
    try{
        const {comment_id, like} = allData
        const {data} = postRequest('coach/motion/comment/like', { comment_id, like: like === 0 ? true : false })
        return data
    }
    catch(err){
        console.log(err)
    }
})

export const handlePostNewComment = createAsyncThunk('movements/handlePostNewComment', async(commentFormData) => {
    try{
        const {data} = await postRequest('coach/motion/comment', commentFormData)
        return data
    }
    catch(err){

    }
})

const movementsSlice = createSlice({
    name: 'movements',
    initialState: {
        categories: [],
        movements: [],
        comments: [],
        status: {
            categoriesLoading: false,
            movementsLoading: false,
            commentsLoading: false,
            newCommentLoading: false,
            isNotMoreComment: true,
            closeNewCommentModal: false
        }
    },
    reducers: {
        setCommentsLoading: (state, action) => {
            state.status.commentsLoading = action.payload
        },
        setComments: (state, action) => {
            state.comments = action.payload
        },
        setCloseNewCommentModal: (state, action) => {
            state.status.closeNewCommentModal = action.payload
        },
        changeLikeCount: (state, action) => {
            if(action.payload.type === 'add'){
                ++state.comments[action.payload.index].likes_count
            }
            else if(action.payload.type === 'minus'){
                --state.comments[action.payload.index].likes_count
            }
        }
    },
    extraReducers(builder){
        builder
            .addCase(handleGetCategories.fulfilled, (state, action) => {
                state.categories = action.payload
                state.status.categoriesLoading = false
            })
            .addCase(handleGetCategories.pending, (state, action) => {
                state.status.categoriesLoading = true
            });
        builder
            .addCase(handleGetMovements.fulfilled, (state, action) => {
                state.movements = action.payload
            });
        builder
            .addCase(handleGetComments.fulfilled, (state, action) => {
                const data = action.payload.data
                if ((data?.length > 0 && action?.payload?.isNotMoreComments) || action?.payload?.tempPage === 1) {
                    if (action?.payload?.tempPage === 1) {
                        state.comments = data
                    } else {
                        state.comments = [...state.comments, ...data]
                    }
                }
                if (data.length >= 20) {
                    state.status.isNotMoreComment = true
                } else {
                    state.status.isNotMoreComment = false
                }
                state.status.commentsLoading = false
            })
            .addCase(handleGetComments.pending, (state, action) => {
                state.status.commentsLoading = true
            })
            .addCase(handleGetComments.rejected, (state, action) => {
                state.status.commentsLoading = 'error'
            });
        builder
            .addCase(handleLikeComment.fulfilled, (state, action) => {
                state.status.commentsLoading = false
            })
            .addCase(handleLikeComment.pending, (state, action) => {
                state.status.commentsLoading = true
            })
            .addCase(handleLikeComment.rejected, (state, action) => {
                state.status.commentsLoading = false
            });
        builder
            .addCase(handlePostNewComment.fulfilled, (state, action) => {
                if(action.payload.is_successful){
                    state.status = {...state.status,
                        commentsLoading: 'sentData',
                        newCommentLoading: false,
                        closeNewCommentModal: true
                    }
                }
            })
            .addCase(handlePostNewComment.pending, (state, action) => {
                state.status = {...state.status,
                    commentsLoading: 'sendingData',
                    newCommentLoading: true,
                }
            })
            .addCase(handlePostNewComment.rejected, (state, action) => {
                state.status = {...state.status,
                    commentsLoading: 'error',
                    newCommentLoading: false,
                }
            })
    }
})

export const {setCommentsLoading, setComments, setCloseNewCommentModal, changeLikeCount} = movementsSlice.actions
export const selectCategories = state => state.movements.categories
export const selectMovements = state => state.movements.movements
export const selectComments = state => state.movements.comments
export const selectCategoriesLoading = state => state.movements.status.categoriesLoading
export const selectMovementsLoading = state => state.movements.status.movementsLoading
export const selectCommentsLoading = state => state.movements.status.commentsLoading
export const selectNewCommentLoading = state => state.movements.status.newCommentLoading
export const selectIsNotMoreComment = state => state.movements.status.isNotMoreComment
export const selectCloseNewCommentModal = state => state.movements.status.closeNewCommentModal

export default movementsSlice.reducer